import React from 'react'
import { getValue } from 'remote-config-value'
import { Dialog } from 'functional-foundations'
import { makeStyles } from '@material-ui/core/styles'
import { DialogProps } from 'functional-foundations/types'
import { Button, Icon, Typography } from 'foundations-library/components'

const useStyles = makeStyles((theme) => {
    const { colors } = theme['foundations-library']

    return {
        dialog: {
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 20,
            textAlign: 'center'
        },
        header: {
            width: '100%',
            paddingTop: 20,
            paddingBottom: 10
        },
        titleRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 4,
            marginBottom: 10
        },
        title: {
            color: colors.destructive[600],
            letterSpacing: '-0.2px'
        },
        message: {
            color: colors.neutral[900]
        },
        supportPhone: {
            color: colors.primary[500],
            letterSpacing: '-0.2px',
            marginTop: 10
        },
        actions: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 20
        },
        button: {
            minWidth: 90
        },
        retryButton: {
            paddingLeft: 8,
            paddingRight: 16
        }
    }
})

type PropsType = {
    onRetry(): unknown
    onCancel?(): unknown
} & DialogProps

/**
 *
 */
const PaymentErrorDialog = ({
    onRetry,
    onCancel,
    ...props
}: PropsType): JSX.Element => {
    const classes = useStyles()
    const hasCancelState = typeof onCancel === 'function'

    return (
        <Dialog
            width={600}
            className={classes.dialog}
            closeOnClickOutside={false}
            data-testid='payment-error-dialog'
            {...props}
        >
            <div className={classes.content}>
                <div className={classes.header}>
                    <div className={classes.titleRow}>
                        <Icon name='cancel' size={40} color='destructive-600' />
                        <Typography variant='h6' className={classes.title} data-testid='payment-error-dialog-message'>
                            Something went wrong
                        </Typography>
                    </div>
                    <Typography variant='body1' className={classes.message}>
                        Something went wrong while loading your payment details.
                    </Typography>
                    {
                        hasCancelState &&
                        <>
                            <Typography variant='body1' className={classes.message} data-testid='payment-error-dialog-please-contact'>
                                Please contact support if the issue persists at:
                            </Typography>
                            <Typography variant='h8' className={classes.supportPhone} data-testid='payment-error-dialog-phone-number'>
                                {getValue('sms_registration_support_phone_number')}
                            </Typography>
                        </>
                    }
                </div>
                <div className={classes.actions}>
                    {
                        hasCancelState &&
                        <Button
                            variant='outlined'
                            color='neutral'
                            className={classes.button}
                            onClick={onCancel}
                            data-testid='payment-error-dialog-cancel-btn'
                        >
                            Cancel
                        </Button>
                    }
                    <Button
                        color='primary'
                        icon='refresh'
                        iconLeft
                        className={`${classes.button} ${classes.retryButton}`}
                        onClick={onRetry}
                        data-testid='payment-error-dialog-try-again-btn'
                    >
                        Try Again
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}

export default PaymentErrorDialog
